import { ConditionWithId } from "../ExpressionEditor";

export const hasConditionWithValue = (conditions: ConditionWithId[]): boolean => {
  return conditions.some(c => !["exists", "notexists"].includes(c.comparator));
};
